import { createSelector } from '@reduxjs/toolkit';
import { selectSuburbanUtilitiesValue } from './selectSuburbanUtilitiesValue';
import { ESuburbanUtility } from '../../../../packages/JsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Электричество', value: ESuburbanUtility.Electricity },
  { label: 'Газ', value: ESuburbanUtility.Gas },
  { label: 'Водоснабжение', value: ESuburbanUtility.Water },
  { label: 'Канализация', value: ESuburbanUtility.Drainage },
];

export const selectSuburbanUtilitiesFilter = createSelector(selectSuburbanUtilitiesValue, value => ({
  label: 'Коммуникации',
  value,
  options: OPTIONS,
}));
